export enum PastClassFinalizationStatusEnum {

  Unfulfilled = 1,
  Regular = 2,
  FinishedEarly = 3

}
